module.exports = __webpack_public_path__ + "img/Walnut PPP v2.77b923b1.png";